/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ProcessVariant = {
    NotSpecified: 'NotSpecified',
    FirstRun: 'FirstRun',
    SecondRun: 'SecondRun',
    ThirdRun: 'ThirdRun',
    FirstSettlement: 'FirstSettlement',
    SecondSettlement: 'SecondSettlement',
} as const;
export type ProcessVariant = typeof ProcessVariant[keyof typeof ProcessVariant];

